var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: [_vm.$style.example_content_item] }, [
    _c("div", { class: _vm.$style.example_content_item_title }, [
      _vm._v("\n    " + _vm._s(_vm.title) + "\n  "),
    ]),
    _vm._v(" "),
    _c("div", { class: _vm.$style.example_content_2_items }, [
      _c(
        "div",
        {
          class: _vm.$style.example_block,
          on: {
            click: function () {
              return _vm.onCreateReport(
                "project",
                _vm.timeTitleLocales.timeByProjects
              )
            },
          },
        },
        [
          _c(
            "div",
            { class: _vm.$style.example_block_title },
            [
              _c("div", { class: _vm.$style.text }, [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.locale("" + _vm.timeTitleLocales.timeByProjects)
                    ) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("vgp-button", {
                class: _vm.$style.example_create_but,
                attrs: {
                  type: "text",
                  small: true,
                  label: _vm.locale("common_create"),
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { class: _vm.$style.example_block_desc }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.locale("exmp_chart_time_project_desc")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("div", { class: _vm.$style.example_block_chart }, [
            _c("img", {
              class: _vm.$style.img,
              attrs: {
                src: "https://cdn.ganttpro.com/app/imgs/reports/reportTimeProject.png",
              },
            }),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          class: _vm.$style.example_block,
          on: {
            click: function () {
              return _vm.onCreateReport(
                "month",
                _vm.timeTitleLocales.timeByMonth
              )
            },
          },
        },
        [
          _c(
            "div",
            { class: _vm.$style.example_block_title },
            [
              _c("div", { class: _vm.$style.text }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.locale("" + _vm.timeTitleLocales.timeByMonth)) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("vgp-button", {
                class: _vm.$style.example_create_but,
                attrs: {
                  type: "text",
                  small: true,
                  label: _vm.locale("common_create"),
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { class: _vm.$style.example_block_desc }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.locale("exmp_chart_time_by_month_desc")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("div", { class: _vm.$style.example_block_chart }, [
            _c("img", {
              class: _vm.$style.img,
              attrs: {
                src: "https://cdn.ganttpro.com/app/imgs/reports/reportTimeMonth.png",
              },
            }),
          ]),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("div", { class: _vm.$style.example_content_2_items }, [
      _c(
        "div",
        {
          class: _vm.$style.example_block,
          on: {
            click: function () {
              return _vm.onCreateReport(
                "timeloglist",
                "exmp_chart_time_log_title"
              )
            },
          },
        },
        [
          _c(
            "div",
            { class: _vm.$style.example_block_title },
            [
              _c("div", { class: _vm.$style.text }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.locale("exmp_chart_time_log_title")) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("vgp-button", {
                class: _vm.$style.example_create_but,
                attrs: {
                  type: "text",
                  small: true,
                  label: _vm.locale("common_create"),
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { class: _vm.$style.example_block_desc }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.locale("exmp_chart_time_log_desc")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("div", { class: _vm.$style.example_block_chart }, [
            _c("img", {
              class: _vm.$style.img,
              attrs: {
                src: "https://cdn.ganttpro.com/app/imgs/reports/reportTimelog.png",
              },
            }),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }